import InvoiceCountBadge from './invoice-count-badge'
import QuoteCountBadge from './quote-count-badge'
import VipBadge from './vip-badge'

type PropType = {
  isVIP: boolean
  isNewCustomer: boolean
  invoiceCount: number
  quoteCount: number
}
const CallBadgeContainer = (props: PropType) => {
  return !props.isNewCustomer ? (
    <div className="flex justify-start items-center mx-4">
      {props.isVIP && <VipBadge />}
      <InvoiceCountBadge invoiceCount={props.invoiceCount} />
      <QuoteCountBadge quoteCount={props.quoteCount} />
    </div>
  ) : null
}

export default CallBadgeContainer
